<div class="login-page">
    <div class="login-card">
        <dx-load-panel [visible]="showSpinner"
                       [showIndicator]="true"
                       [showPane]="true"
                       [shading]="true"
                       [hideOnOutsideClick]="false"
                       message="Signing in..."
                       [position]="{ of: '.login-card' }"></dx-load-panel>

        <h4>Chatbot</h4>

        <form [formGroup]="loginForm"
              (ngSubmit)="performLogin()"
              class="login-form">
            <div class="field-row">
                <dx-text-box formControlName="email"
                             mode="email"
                             label="Email"
                             labelMode="floating"
                             stylingMode="outlined"
                             placeholder="name@example.com"
                             [isValid]="!emailInvalid"
                             valueChangeEvent="keyup"
                             [validationErrors]="emailInvalid ? [{ message: 'Enter a valid email address' }] : []"></dx-text-box>
            </div>

            <div class="field-row">
                <dx-text-box formControlName="password"
                             mode="password"
                             label="Password"
                             labelMode="floating"
                             stylingMode="outlined"
                             placeholder="Your password"
                             [isValid]="!passwordInvalid"
                             valueChangeEvent="keyup"
                             [validationErrors]="passwordInvalid ? [{ message: 'Password must be at least 6 characters' }] : []"></dx-text-box>
            </div>

            <div class="button-row">
                <dx-button text="Login"
                           type="success"
                           [useSubmitBehavior]="true"
                           [disabled]="loginForm.invalid || showSpinner"></dx-button>

                <dx-button text="Cancel"
                           type="normal"
                           stylingMode="outlined"
                           [disabled]="showSpinner"
                           (onClick)="cancel()"></dx-button>

                <dx-button text="New Account"
                           type="default"
                           stylingMode="outlined"
                           class="ms-auto"
                           [disabled]="showSpinner"
                           (onClick)="registerNewAccount()"></dx-button>
            </div>
        </form>

        @if (statusMessage) {
        <div class="status-message"
             [class.error]="statusKind === 'error'"
             [class.success]="statusKind === 'success'">
            {{statusMessage}}
        </div>
        }
    </div>
</div>
